import { ReactElement } from 'react'

import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { Icon, Text } from 'components/core'

import { NavButton } from './NavButton'
import * as styles from './styles.scss'

export type GetHelpNavItemProps = {
    disabled?: boolean
}

export const GetHelpNavItem = ({
    disabled = false,
}: GetHelpNavItemProps): ReactElement | null => {
    const { t } = useTranslation('common')

    const helpButton = (
        <NavButton id="get-help-button" disabled={disabled}>
            <Icon name="HELP_CIRCLE" size={18} />
            <Text fontWeight={500} color="textMuted">
                {t('common:getHelp', 'Get Help')}
            </Text>
        </NavButton>
    )

    if (disabled) {
        return (
            <Tooltip
                title={t(
                    'common:getHelpDisabledWhenOrgLocked',
                    'Get Help is unavailable while your organization is locked.'
                )}
            >
                <span className={styles.helpNavItemDisabledWrap}>
                    {helpButton}
                </span>
            </Tooltip>
        )
    }

    return helpButton
}
